module.exports = __webpack_public_path__ + "img/background_2.d0d775dd.svg";